export type FileTypeDescription = {
  key:
    | 'WORD'
    | 'EXCEL'
    | 'POWERPOINT'
    | 'PDF'
    | 'IMAGE'
    | 'VIDEO'
    | 'AUDIO'
    | 'WEBLINK'
    | 'YOUTUBE'
    | 'H5P'
    | 'GEOGEBRA'
    | 'UNKNOWN';
  mimetypes: string[];
  iconUrl?: string;
};

export const fileTypeDescriptions: FileTypeDescription[] = [
  {
    key: 'WORD',
    mimetypes: [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
      'application/vnd.ms-word.document.macroEnabled.12',
      'application/vnd.ms-word.template.macroEnabled.12',
      'application/vnd.ms-word.document.macroenabled.12',
      'application/vnd.ms-word.template.macroenabled.12',
    ],
  },
  {
    key: 'EXCEL',
    mimetypes: [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
      'application/vnd.ms-excel.sheet.macroEnabled.12',
      'application/vnd.ms-excel.template.macroEnabled.12',
      'application/vnd.ms-excel.addin.macroEnabled.12',
      'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
      'application/vnd.ms-excel.sheet.macroenabled.12',
      'application/vnd.ms-excel.template.macroenabled.12',
      'application/vnd.ms-excel.addin.macroenabled.12',
      'application/vnd.ms-excel.sheet.binary.macroenabled.12',
    ],
  },
  {
    key: 'POWERPOINT',
    mimetypes: [
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    ],
  },
  {
    key: 'PDF',
    mimetypes: ['application/pdf'],
  },
  {
    key: 'IMAGE',
    mimetypes: ['image/'],
  },
  {
    key: 'VIDEO',
    mimetypes: ['video/mp4'],
  },
  {
    key: 'AUDIO',
    mimetypes: ['audio/mp4', 'audio/mpeg', 'audio/mp3'],
  },
  {
    key: 'WEBLINK',
    mimetypes: ['weblink'],
  },
  {
    key: 'YOUTUBE',
    mimetypes: ['youtube'],
  },
  {
    key: 'H5P',
    mimetypes: ['h5p'],
  },
  {
    key: 'GEOGEBRA',
    mimetypes: ['geogebra'],
  },
];

export const getFileTypeDescription = (mimeType: string): FileTypeDescription => {
  const description = fileTypeDescriptions.find(mimeDescription =>
    mimeDescription.mimetypes.find(m => mimeType.indexOf(m) > -1),
  );

  if (!description) {
    return {
      key: 'UNKNOWN',
      mimetypes: [],
    };
  }

  return description;
};
